import Navigation from './components/Navigation';
import PricingHero from './components/PricingHero';
import PricingTiers from './components/PricingTiers';
import WhyFounder from './components/WhyFounder';
import TheMath from './components/TheMath';
import WhoItsFor from './components/WhoItsFor';
import WhatFoundersGet from './components/WhatFoundersGet';
import SpotsRemaining from './components/SpotsRemaining';
import PricingFAQ from './components/PricingFAQ';
import FinalCTA from './components/FinalCTA';
import PricingFooter from './components/PricingFooter';

export default function Pricing() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <PricingHero />
      <PricingTiers />
      <WhyFounder />
      <TheMath />
      <WhoItsFor />
      <WhatFoundersGet />
      <SpotsRemaining />
      <PricingFAQ />
      <FinalCTA />
      <PricingFooter />
    </div>
  );
}
